import React from "react"
import styled from "styled-components"
import iconBox from "../assets/images/box-icon.png"
import cards from "../assets/images/tarjetas.svg"
import media from "../styles/media"

const Container = styled.div`
  text-align: center;
  font-family: Muller;
  font-style: normal;
  font-weight: normal;
  font-size: 28px;
  line-height: 34px;
  color: #58595b;
  display: flex;
  align-items: center;

  & .tax{
    font-family: Muller;
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    color: #58595B;
  }

  & .porcentage{
    font-family: Muller;
    font-style: normal;
    font-weight: 800;
    font-size: 40px;
    color: #1F2122;
  }
  ${media.md`
  background-image: none !important;
  display: block;
  height: auto !important;

`};

& .responsive{
    ${media.md`
    padding: 0;
  `};
}
  & .box-white {
    padding: 30px;
    color: #58595B;
    text-align: center;
    background: white;
    margin-bottom: 100px;
    position: relative;
    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.15);
    border-radius: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-right: 40px;
    ${media.md`
        margin-right: 0;
        border-radius: 0;
        padding: 15px;
        margin-bottom: 0;
  `};
  }
  & .image-center {
    margin: 0 auto;
    padding: 15px;
  }
  & .differ {
    width: 400px;
    max-width: 100%;
    position: relative;
    margin-top: 2rem;
    border: solid 1px gray;
    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.15);
    border-radius: 30px;
    padding: 2rem;
  }

  & .subtitle{
    font-weight: 400;
    font-size: 27px;
    color: #1F2122;
    ${media.md`
        font-size: 20px;
    `};
  }
  & .title{
    font-weight: 800;
    font-size: 60px;
    color: #1F2122;
    ${media.md`
        font-size: 40px;
    `};
    }
& .icon{
    position: absolute;
    bottom: 0;
    left: 0px;
    right: 0;
    top: -15px;
    margin: 0 auto;
    background: #fff;
    max-width: 100%;
}

& .card{
    margin: 0 auto;
    max-width: 100%;
    margin-top: 20px;
}
& .condition{
  font-weight: 300;
  font-size: 14px;
  color: #000;
  padding-top: 10px;
}
`

const Banner = ({ banner, icon, title, subtitle }) => {
  return (
    <Container className="row" style={{background: `url(${banner})`, backgroundSize: 'cover',backgroundRepeat: 'no-repeat', height: '800px',}}  >
      <div className="col-md-6 col-md-offset-6 col-sm-12 responsive">
          <div className="box-white ">
            <p className="tax">{title}</p>
            <p className="porcentage">{subtitle}</p>
            <img src={icon ? icon : ''} onError={''} className="img-responsive image-center" />
            <div className="differ">
                <p className="subtitle">Difiere hasta</p>
                <p className="title">12 meses.*</p>
                <img className="icon" src={iconBox}/>
            </div>
            <img className="card" src={cards}/>
            <p className="condition">*Diferido aplica con interés.</p>
          </div>
      </div>
    </Container>
  )
}

export default Banner



// WEBPACK FOOTER //
// ./src/components/Banner.js